import { loadTemplate, TLoadingComponent } from 'core-components/helpers/lazyLoad'
import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import { sanitize } from 'core-components/helpers/sanitize'

import { IMetaInformation } from '../models/IMetaInformation'

export const metaData = registerSharedDependency<{ [key: string]: IMetaInformation }>(
  'metaData',
  () => ({}) as { [key: string]: IMetaInformation }
)

export const componentsPromises = registerSharedDependency<{
  [key: string]: Promise<TLoadingComponent> | null
}>('componentsPromises', () => ({}) as { [key: string]: Promise<TLoadingComponent> | null })

const registerMeta = (viewModel: string, meta: IMetaInformation) => {
  metaData[viewModel] = meta
}

const registerComponentPromise = (
  viewModel: string,
  componentPromise: Promise<TLoadingComponent> | null
) => {
  componentsPromises[viewModel] = componentPromise
}

export const loadMeta = (viewModel: string, path: string) => {
  const templatePromise = loadTemplate(path)
  registerComponentPromise(viewModel, templatePromise)
  templatePromise?.then((source) => {
    if (source.getMetaInfo) {
      const meta = source.getMetaInfo()
      registerMeta(viewModel, meta)
    } else {
      console.error(`You must declare method getMetaInfo in module ${path}`)
    }
  })
}

export const loadMetaByLoader = ({ loader, id }: { loader: () => Promise<any>; id: string }) => {
  const loaderPromise = loader()
  registerComponentPromise(id, loaderPromise)
  loaderPromise.then((source) => {
    if (source.getMetaInfo) {
      const meta = source.getMetaInfo()
      registerMeta(id, meta)
    } else {
      console.error(sanitize(`You must declare method getMetaInfo in module ${id}`))
    }
  })
}

export const getWidgetMeta = (viewModel: string): IMetaInformation => {
  return metaData[viewModel] || {}
}

export const getAsyncWidgetMeta = async (viewModel: string): Promise<IMetaInformation> => {
  const promise = componentsPromises[viewModel]
  if (!promise) {
    return {}
  }
  const source = await promise
  if (source.getMetaInfo) {
    const meta = source.getMetaInfo()
    registerMeta(viewModel, meta)
    return meta
  }
  return {}
}
